import React from 'react'

import ArrowIcon from '../arrow-icon/ArrowIcon'
import { Link } from 'gatsby'
import { getAllPaths, sortByUid } from '../helpers.js'
import { nextPrevBtnProps } from '../types'

const renderBtnText = () => {
     return (
          <React.Fragment>
               <span className="page-nav__link__icon page-nav__link__icon--prev">
                    <ArrowIcon />
               </span>
               <span className="page-nav__text">Previous</span>
          </React.Fragment>
     )
}
const renderPreviousLink = (arr, location, base) => {
     const currentLocation = location.replace(/\/$/, '')
     arr.sort(sortByUid)
     const allPages = getAllPaths(arr)
     if (currentLocation.includes(base)) {
          const cleanCurrentLocation = currentLocation.substring(
               currentLocation.indexOf('/' + base)
          )
          const currentIndex = allPages.indexOf(cleanCurrentLocation)
          if (currentIndex !== 0) {
               const slug = allPages[currentIndex - 1]
               return (
                    <Link to={slug} className="page-nav__link">
                         {renderBtnText()}
                    </Link>
               )
          } else {
               return (
                    <div className="page-nav__link page-nav__disabled">
                         {renderBtnText()}
                         <span className="visually-hidden">(disabled)</span>
                    </div>
               )
          }
     }
}
const RenderPrevBtn = props => (
     <React.Fragment>
          {renderPreviousLink(props.allSitePage, props.currentView, props.base)}
     </React.Fragment>
)

export default RenderPrevBtn

RenderPrevBtn.propTypes = nextPrevBtnProps
